import { clients } from '@/mocks/multifierros';
import HorizontalScroll from '@/components/feature/HorizontalScroll';

export default function Clients() {
  return (
    <section id="clientes" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <h2 className="font-heading text-4xl md:text-5xl text-foreground-50 tracking-wide text-center mb-10 md:mb-14">
          Nuestros Clientes
        </h2>

        <HorizontalScroll gap={16}>
          {clients.map((client) => (
            <div
              key={client}
              className="flex-shrink-0 w-[200px] md:w-[240px] bg-background-50 rounded-sm h-20 md:h-24 flex items-center justify-center px-4 border border-background-300/40 hover:border-foreground-500 transition-colors cursor-default"
            >
              <span className="text-foreground-300 text-xs md:text-sm font-bold uppercase tracking-wider text-center">
                {client}
              </span>
            </div>
          ))}
        </HorizontalScroll>
      </div>
    </section>
  );
}